import CancelOutlinedIcon from "@mui/icons-material/CancelOutlined"
import CheckCircleOutlinedIcon from "@mui/icons-material/CheckCircleOutlined"
import DoDisturbOnOutlinedIcon from "@mui/icons-material/DoDisturbOnOutlined"
import DoNotDisturbIcon from "@mui/icons-material/DoNotDisturb"
import React from "react"
import { STATUS_ICONS } from "../constants"

/**
 * Renders the appropriate icon for an event status
 * @param {string} status - The event status
 */
const StatusIcon = React.memo(({ status }) => {
  // Map status to icon component
  const getIcon = statusKey => {
    switch (statusKey) {
      case "cancelled_no_show":
        return DoNotDisturbIcon
      case "cancelled":
        return CancelOutlinedIcon
      case "pending":
        return DoDisturbOnOutlinedIcon
      case "finished":
        return CheckCircleOutlinedIcon
      default:
        return null
    }
  }

  const statusConfig = STATUS_ICONS[status]
  if (!statusConfig) return null

  const Icon = getIcon(status)
  if (!Icon) return null

  return <Icon fontSize="small" sx={{ color: statusConfig.color }} />
})

StatusIcon.displayName = "StatusIcon"

export default StatusIcon
